import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import IsoToDateTime, { IsoToDateWithoutTime } from "../../../CommonFunction/IsoDateTime";
import { EditTruck, MatchingTrucks } from "../../../Utils/AllPagesQuriesAndMutations";
import { Loading, LoadTable } from "../../Components";
import { Tabs } from "../../Components/AdminRequestSupportComponents/Tabs";
import BidDetails from "../../Components/FormComponents/AddLoad/Bidding";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import SearchBoxesDiv from "../../Components/HeaderDiv/HeaderDivComponents/SearchBoxesDiv/SearchBoxesDiv";
import { ErrorToast, SuccessToast } from "../../Components/ToastComponent/RectHotToast";
import useFetchTableData from "../../custom_hooks/useFetchTableData";
import "../TruckPost/Truck.scss";
import "../LoadEntry/LoadEntry.scss";
import { convertToAge } from "../../../CommonFunction/ProcessData";
import BidsSP from "../LoadEntry/BidsSP";
import CloseLoad from "../LoadEntry/CloseLoad";
import { MatchingModal } from "../LoadEntry/MatchingTrucks";
import ResultLP from "../LoadEntry/ResultLP";
import SearchSP from "../LoadEntry/SearchSP";
import { Confirm } from "../../Components/Confirmation/Confirm";
import { useModalContext } from "../../Components/Reactportal/ModalContext";

export const EDIT_LOAD = gql`
  mutation editLoad($id: ID!, $userInput: LoadInput) {
    editLoad(id: $id, userInput: $userInput) {
      _id
    }
  }
`;
export const Get_Load_By_Id = gql`
  query loadByID($id: ID) {
    loadByID(ID: $id) {
      AccountData {
        Business_Name
        Business_Mobile_Number
      }

      Load_Manager {
        FullName
        mobileNumber
      }

      Loading_Address_Line_1
      Unloading_Address_Line_1
      Load_Live_Duration

      No_Of_Vehicels_Required

      Notes

      Target_Price

      Total_Weight
      Material_Category
      Exact_Content
      Load_Type
      Payment_Percentage
      VehicleCategoryGroupData {
        VehicleType
        VehicleCategory {
          Name
        }
      }
      createdAt
    }
  }
`;

const getCount = gql`
  mutation {
    GetLatestCountofMatchingTrucks {
      _id
      L1
      Exact_Content
      Load_Manager
      From_City
      Loading_Date
      To_City
      Unique_Id
      Vehicle_Type
      Weight_Category
      Unloading_Scope
      Unloading_State
      Unloading_Landmark
      Unloading_Name
      Unloading_City
      Truck_Type
      Unloading_Area
      Loading_Scope
      Loading_Time
      Loading_State
      Loading_Pincode
      Loading_Name
      Loading_Landmark
      Loading_Area
      Loading_By
      Loading_City
      Total_Weight
      Target_Price
      Rate_per
      Over_Dimension_Cargo
      Payment_Type
      Notes
      No_Of_Vehicels_Required
      Material_Dimension
      Material_Insurence
      Material_Category
      Load_Live_Duration
      Expected_Price
      Dangerous_Goods
      Auction_Time
      Auction_Date
      createdAt
      updatedAt
      Is_Audit
      Account_Manager
      Matching_Trucks_Count
    }
  }
`;

const queryfunction = (fields) => {
  const query = gql`
    query getallloads($Is_Live: Boolean, $Is_Archive: Boolean) {
        getallloads(Is_Live: $Is_Live, Is_Archive: $Is_Archive) {
        ${fields?.join(" ")}
        _id
      }
    }
  `;

  return query;
};

const getCategoryFromTab = (tab) => {
  switch (tab) {
    case "Live":
      return { Is_Live: true };
    case "Expired":
      return { Is_Live: false };
    case "All_Trucks":
      return {};
    default:
      return {};
  }
};

const LoadEntry = () => {
  const { pushKey, popKey } = useModalContext();
  const [isLoading, setIsLoading] = useState(true);
  const title = "My_Loads";
  const [selectedCate, setSelectedCate] = useState({
    Is_Live: true,
    Is_Archive: false,
  });
  const [formdata, setformdata] = useState(null);
  const [Tab, SetTab] = useState("Live");
  const [showResultModal, setShowResultModal] = useState(false);
  const [showSearchSPModal, setShowSearchSPModal] = useState(false);
  const [showBidModal, setShowBidModal] = useState(false);
  const [showMatchingTrucks, setMatchingTrucks] = useState(false);
  const [showBidsSPModal, setShowBidsSPModal] = useState(false);
  const [showCloseModal, setShowCloseModal] = useState(false);
  const [loadVehicleDetails, setLoadVehicleDetails] = useState({});
  const [loadingState, setLoading] = useState(true);
  const [LoadId, setLoadId] = useState("");
  let fieldKey = "Search SP";
  const dispatch = useDispatch();
  const ReduxData = useSelector((store) => store.UniqueTableReducer);
  const fielddata = ReduxData?.My_Loads?.Selected_Row;

  const [fetchAllLoad, { loading: queryLoading, error, data }] = useLazyQuery(queryfunction([]), {
    variables: getCategoryFromTab(Tab),
    fetchPolicy: "cache-and-network",

    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
    notifyOnNetworkStatusChange: true,
    onCompleted: () => {
      setIsLoading(false);
    },
    onError: () => {
      setIsLoading(false);
    },
  });

  const [RefetchCount] = useMutation(getCount, {
    fetchPolicy: "network-only",

    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [EditLoad, { loading: EditTruckLoading }] = useMutation(EDIT_LOAD, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  let statusTab = [{ name: "Live" }, { name: "Expired" }, { name: "All_Loads" }];

  const { loading,TableHeaders }= useFetchTableData(queryfunction, fetchAllLoad, setIsLoading, title);
console.log(TableHeaders, 'TableHeadersTableHeadersTableHeaders')
  useEffect(() => {
    dispatch({ type: "Clear_Errors" });
  }, []);

  useEffect(() => {
    if (queryLoading) {
      setIsLoading(queryLoading);
    }
  }, [queryLoading]);

  useEffect(() => {
    if (error) {
      ErrorToast(error.message);
    }
  }, [error]);

  let handleBidModalfuc = (Loadid) => {
    setLoadId(Loadid);
    setShowBidModal(true);
  };

  let handleLoadClosefuc = async (Loadid) => {
    setLoadId(Loadid);
    setShowCloseModal(true);
  };

  let handleResultModalfuc = (Loadid, No_Of_Vehicels_Required, Load_Post_Type) => {
    setLoadId(Loadid);
    setLoadVehicleDetails({ No_Of_Vehicels_Required, Load_Post_Type });
    setShowResultModal(true);
  };

  let handleBidsSPModalfuc = (Loadid) => {
    setLoadId(Loadid);
    setShowBidsSPModal(true);
  };

  let handleSearchSPModalfuc = (Loadid) => {
    setLoadId(Loadid);
    setShowSearchSPModal(true);
  };

  let handleMatchingTruckModalfuc = (LoadId) => {
    setLoadId(LoadId);
    setMatchingTrucks(true);
  };

  const RefreshFunction = () => {
    RefetchCount().then((res) => {
      SuccessToast("Count updated...!");
    });
  };

  useEffect(() => {
    dispatch({ type: "TabData", payload: { tab: "Live" } });
  }, []);

  useEffect(() => {
    const Tabdata = {
      key: title,
      data: Tab,
    };
    dispatch({ type: "UNIQUE_TAB_SELECT", payload: Tabdata });
    popKey();
    pushKey(title);
    dispatch({ type: "Refetch", payload: true }); 

  }, [Tab]);

  useEffect(() => {
    setLoading(true);
    let updatedData = data?.getallloads?.map((el) => {
      let obj = { ...el };
      delete obj.__typename;
      obj.Age = convertToAge(obj.createdAt);
      if (obj?.Date) {
        obj.Date = IsoToDateWithoutTime(obj?.Date);
      }
      if (obj?.createdAt) {
        obj.createdAt = IsoToDateTime(obj?.createdAt);
      }
      if (obj?.updatedAt) {
        obj.updatedAt = IsoToDateTime(obj?.updatedAt);
      }
      if (obj?.Loading_Date) {
        obj.Loading_Date = IsoToDateWithoutTime(obj?.Loading_Date);
      }

      obj.Bid_Now = obj.Is_Archive ? (
        "Bid Now"
      ) : (
        <a href="#" style={{ color: "blue", textDecoration: "none" }} onClick={() => handleBidModalfuc(obj._id)}>
          {" "}
          Bid Now
        </a>
      );
      obj.Search_SP = (
        <a href="#" style={{ color: "blue", textDecoration: "none" }} onClick={() => handleSearchSPModalfuc(obj._id)}>
          Search SP
        </a>
      );

      obj.Matching_Trucks = obj?.Matching_Trucks_Count ? (
        <a
          href="#"
          style={{ color: "blue", textDecoration: "none" }}
          onClick={() => handleMatchingTruckModalfuc(obj._id)}
        >
          Matching Trucks
        </a>
      ) : (
        "No Matching Trucks"
      );
      obj.Result_LP = (
        <a
          href="#"
          style={{ color: "blue", textDecoration: "none" }}
          onClick={() => handleResultModalfuc(obj._id, obj.No_Of_Vehicels_Required, obj.Load_Post_Type)}
        >
          Result LP
        </a>
      );
      obj.Bids_SP = (
        <a href="#" style={{ color: "blue", textDecoration: "none" }} onClick={() => handleBidsSPModalfuc(obj._id)}>
          Bids SP
        </a>
      );
      delete obj.Is_Archive;
      return obj;
    });
    setformdata(updatedData);
    setLoading(false);
  }, [data]);

  const closeFunction = () => {
    handleLoadClosefuc(fielddata._id);
  };

  return (
    <div className="LoadContainer">
      {/* <div className="HeaderDiv">
        <div>
          <p className="pageTitle">My Loads Data</p>
          <div className="hr1ForPageTitle"></div>
        </div>
        <SearchBoxesDiv />
      </div> */}
      <HeaderDiv title={"Load Board"} func={RefreshFunction} TableKey={title} closeFun={closeFunction} MoreActions={{Is_Close:true}}/>
      <Tabs tabs={statusTab} SetTabPage={SetTab}/>

      {
        <>
          {/* {isLoading ? (
            <Loading />
          ) : !formdata?.length ? (
            <p className="DataNotAvailable">Data not Available</p>
          ) : (
            <>
              {queryLoading && <div className="loader-line-div" />}
              <LoadTable title={title} data={formdata} loading={isLoading} error={error} />
            </>
          )} */}
     {loading && (!formdata || formdata.length === 0) && <Loading />}
        {!loading && (!formdata || formdata.length === 0) && (
          <p className="DataNotAvailable">Data not Available</p>
        )}
       {formdata && formdata.length > 0 && (
        <>
          {/* 4) If re-fetching (loading again) but we already have data, show inline loader */}
          {loading && <div className="loader-line-div" />}

          <LoadTable
            data={formdata}
            loading={""}
            error={error}
            title={title}
            Tab={Tab}
            TableHeaders={TableHeaders}
          />
        </>
      )}
          {showBidModal && (
            <BidDetails show={showBidModal} LoadId={LoadId} setShowModal={() => setShowBidModal(!showBidModal)} />
          )}
          {showResultModal && (
            <ResultLP
              show={showResultModal}
              LoadId={LoadId}
              loadVehicleDetails={loadVehicleDetails}
              setShowModal={() => setShowResultModal(!showResultModal)}
            />
          )}
          {showSearchSPModal && (
            <SearchSP
              show={showSearchSPModal}
              LoadId={LoadId}
              setShowModal={() => setShowSearchSPModal(!showSearchSPModal)}
              Key={fieldKey}
            />
          )}
          {showMatchingTrucks && (
            <MatchingModal
              TypeofPortal={"Matching Truck"}
              show={showMatchingTrucks}
              Id={LoadId}
              setShowModal={() => setMatchingTrucks(!showMatchingTrucks)}
              query={MatchingTrucks}
              dataKey="getMatchingTrucksForLoad"
              dataById={Get_Load_By_Id}
              Edit={EditTruck}
            />
          )}
          {showBidsSPModal && (
            <BidsSP show={showBidsSPModal} LoadId={LoadId} setShowModal={() => setShowBidsSPModal(!showBidsSPModal)} />
          )}
          {showCloseModal && (
            <CloseLoad show={showCloseModal} LoadId={LoadId} setShowModal={() => setShowCloseModal(!showCloseModal)} />
          )}
        </>
      }
    </div>
  );
};

export default LoadEntry;
